<!-- App shell center -->
<div class="app-shell" #shell>
  <!-- ... content ... -->

  <nav class="navbar navbar-light background-grey sticky-top shadow-sm app-topbar p-0">
    <div class="container-fluid">

      <!-- ROW 1: title - guest - language -->
      <div class="d-flex align-items-center w-100" *ngIf="qrCodeType === 1">
        <div class="font-weight-bold text-uppercase">
          {{userInfo && userInfo.firstName ? userInfo.firstName : 'Guest'}}
        </div>
        <div class="mx-auto">
          <span *ngIf="serviceType === 'DINE_IN'">TABLE - {{tableName}}</span>
        </div>
        <div class="ms-auto">
          <app-language-component (languageSelected)="onLanguageSelected($event)"></app-language-component>
        </div>
      </div>

      <div class="d-flex align-items-center w-100" *ngIf="qrCodeType !== 1">
        <div class="font-weight-bold text-uppercase">{{userInfo && userInfo.firstName ? userInfo.firstName : 'Guest'}}
        </div>
        <div class="mx-auto">
          <div class="dropdown-box cursor sub-menu" (click)="selectService()">
            <span class="dropdown-text">{{ serviceType === 'DINE_IN' ? 'DINE IN' : (serviceType === 'DELIVERY' ?
              'DELIVERY' : 'PICK UP') }}</span>
            <div class='arrow'></div>
          </div>
        </div>
        <div class="ms-auto">
          <app-language-component (languageSelected)="onLanguageSelected($event)"></app-language-component>
        </div>
      </div>

      <!-- ROW 2: search + menu icon -->
      <div class="d-flex w-100 align-items-center gap-2 mb-1">
        <!-- Phần 1: Loyalty -->
        <div style="flex:1;" *ngIf="userInfo && userInfo.userPkid">
          <div class="text-primary fa-xs-small-70">{{userInfo.loyalty_tier}}</div>
          <div class="text-primary fa-xs-small-70">Loyalty Bal: {{userInfo.points - usedPoints}} /
            <span *ngIf="userSelectedStore">
              <small *ngIf="settings && settings.company_currency_position === 'BACK'">
                {{settings.company_currency}}
              </small>
              {{(loyaltyAmount)?.toFixed(2)}}
              <small *ngIf="settings && settings.company_currency_position === 'FRONT'">
                {{settings.company_currency}}
              </small>
            </span> <span class="font-weight-bold cursor" (click)="checkMore()">Check more</span>
          </div>
        </div>

        <!-- Phần 2: Search -->
        <div class="flex-grow-1" style="flex:1;">
          <input [(ngModel)]="searchValue" (ngModelChange)="onKey($event)" class="search" type="search" required>
        </div>

        <!-- Phần 3: Nav -->
        <div style="width:10px; text-align:right;">
          <button type="button" class="btn btn-link p-0" (click)="openDrawer()">
            <span style="cursor:pointer">&#9776;</span>
          </button>
        </div>
      </div>



    </div>
  </nav>

  <div class="menu-scroll-container" #scrollRoot (scroll)="onMenuScroll(scrollRoot)">
    <div id="itemList" class="container background-grey" *ngIf="!ecomservice.loadingPage.loading"
      style="overflow-x: hidden;">

      <!-- form group -->

      <div *ngIf="qrCodeType === 3 && showBanner && !item_searched"
        class="row background-grey pt-1 margin-fixed-header">
        <div class="card col p-0 cursor">
          <div *ngIf="locationSelected && locationSelected.oocls_slider_promotional_message"
            style="border: 1px solid black !important; border-radius: 1px !important; background:purple; position: absolute; top: 25%;">
            <span
              class="text-white p-2 font-weight-bold-500 font-size-16">{{ecomservice.htmlUtil.textTruncate(locationSelected.oocls_slider_promotional_message,25)}}</span>
          </div>
          <div *ngIf="locationSelected && locationSelected.oocls_slider_promotional_message1"
            style="border: 1px solid black !important; border-radius:1px !important; background: purple; position: absolute; top: 45%;">
            <span
              class="text-white p-2 font-weight-bold-500 font-size-16">{{ecomservice.htmlUtil.textTruncate(locationSelected.oocls_slider_promotional_message1,25)}}</span>
          </div>
          <div class="scrolling-wrapper pb-0" style="width: 100% !important;">
            <carousel [showIndicators]="false">
              <div *ngFor="let promo of banners;let i=index">
                <slide *ngIf="promo">
                  <img class="carousel-image" [defaultImage]="defaultImage" [lazyLoad]="promo" alt="olarme promo"
                    style="display: block; width: 100%;">
                  <div *ngFor="let promotion of promotions; let i = index" [ngClass]="'discount-item'"
                    [ngStyle]="{'top': 10 + i * 10 + '%'}">
                    <span class="text-white p-2 font-size-11">{{ promotion }}</span>
                  </div>

                </slide>
              </div>
            </carousel>

          </div>
        </div>
      </div>

    


      <div>

        <div *ngIf="!item_searched" id="main_menu">
          <div class="row mb-2" *ngIf="recommendedItems.length > 0 && showRecommended">
            <div class="col">

              <!-- Flexbox container added to align spans left/right -->
              <div class="d-flex justify-content-between align-items-center">

                <!-- Existing Left Span -->
                <span class="h5 cursor" style="color: #66509a" (click)="scrollPage()">
                  <img style="width: 15%; height: auto;" src="assets/images/homeicons/Recommendation.png" alt="">
                  {{ 'HOME_PAGE.HIGHLY_RECOMMENDED' | translate }}
                </span>

                <!-- New Right Span -->
                <button *ngIf="showBuyGiftCard" (click)="openGiftCard()" type="button" class="btn btn-xs color-white"
                  style="background-color: #ff8d16;">
                  Gift Cards
                </button>

              </div>

              <div class="row">

                <div class="col-6" [@inOutAnimation]="'in'" *ngFor="let rItem of recommendedItems;let i=index;">
                  <ng-container *ngTemplateOutlet="cardTemplate; context: { item: rItem,index: i }"></ng-container>
                </div>
              </div>
            </div>
          </div>

          <div class="main">
            <div class="row" *ngIf="showOurMenu">
              <div class="col">
                <!-- Flexbox container added to align spans left/right -->
                <div class="d-flex justify-content-between align-items-center">

                  <!-- Existing Left Span -->
                  <span class="h5 cursor" style="color: #66509a" (click)="scrollPage()">
                    <img style="width: 15%; height: auto;" src="assets/images/homeicons/Menu.png" alt="">
                    {{ 'HOME_PAGE.OUR_MENU' | translate }}
                  </span>

                  <!-- New Right Span -->
                  <button (click)="openGiftCard()" *ngIf="!recommendedItems.length" type="button"
                    class="btn btn-xs color-white" style="background-color: #ff8d16;">
                    Gift Cards
                  </button>

                </div>
              </div>
            </div>

            <div class="row" @myInsertRemoveTrigger *ngIf="isHorizontalMenu && !item_searched">
              <div class="category-scroll shadow-sm w-100">
                <div class="category-item" *ngFor="let category of newCategoryList; let i = index">

                  <div class="category-circle" [ngClass]="{'active': selectedMenuId === category.ooic_pkid}"
                    (click)="onMenuClick(category,i)">
                    <img class="category-image" *ngIf="category.ooic_image.length" [defaultImage]="defaultImage"
                      [lazyLoad]="category.ooic_image" />

                    <img class="category-image" *ngIf="!category.ooic_image.length" [defaultImage]="defaultImage"
                      [lazyLoad]="defaultItemImage" />
                  </div>

                  <span class="category-text" [ngClass]="{'active': selectedMenuId === category.ooic_pkid}">
                    {{
                    showALTLanguage && category.ooic_alternative_name
                    ? category.ooic_alternative_name
                    : category.ooic_name
                    }}
                  </span>

                </div>
              </div>
              <div class="right-menu-container cursor" style="display: none;">
                <div class="square-container" (click)="mainPage()">
                  <img src="assets/images/homeicons/Menu.png" alt="Image" class="square-image">
                  <span class="square-text">Main Menu</span>
                </div>
              </div>
            </div>

            <!-- Sections -->

            <ng-container *ngIf="isHorizontalMenu && !item_searched">
              <section *ngFor="let category of newCategoryList; let idx = index; trackBy: trackByMenu"
                class="menu-section" #sectionEl>

                <h3 class="menu-title">{{showALTLanguage === true && category.ooic_alternative_name ?
                  category.ooic_alternative_name :
                  category.ooic_name}}</h3>

                <!-- NO SUB -->
                <div class="row" *ngIf="category.loaded && !category.subMenus.length"
                  [ngClass]="{'item-margin-top': !category.subMenus.length && isHorizontalMenu}">
                  <div class="col-6" [@inOutAnimation]="'in'"
                    *ngFor="let item of category.items; let i = index; trackBy: trackByItem">
                    <ng-container
                      *ngTemplateOutlet="cardTemplate; context: { item: item,index: i, cat: category }"></ng-container>
                  </div>

                </div>

                <!-- HAS SUBS -->
                <div class="row" *ngIf="category.loaded && category.subMenus">
                  <ul class="menu-sub">
                    <li *ngFor="let sm of category.subMenus;let s=index;">
                      <a href='javascript:void(0)' (click)="onSubMenuClickNew(category,sm,s)"
                        [ngClass]="{'sub-selected': category.activeSubMenuId === sm.ooic_pkid}">
                        {{showALTLanguage === true &&
                        sm.ooic_alternative_name ?
                        sm.ooic_alternative_name : sm.ooic_name}}</a>
                    </li>
                  </ul>
                </div>

                <div class="row" *ngIf="category.loaded && category.subMenus && category.subMenus.length">
                  <div class="col-6" [@inOutAnimation]="'in'"
                    *ngFor="let item of (category.activeSubMenu ? category.activeSubMenu.items : []); let ii = index; trackBy: trackByItem">
                    <ng-container
                      *ngTemplateOutlet="cardTemplate; context: { item: item, index: ii, cat: category.activeSubMenu }"></ng-container>
                  </div>
                </div>
                <!-- End SUBS -->


                <!-- ADD ON SECTION -->
                <ng-container *ngIf="category.addon_pkid">

                  <div class="row">
                    <div class="col text-center">
                      <button class="btn btn-xs w-50 color-white" style="background-color: #21658b;"
                        (click)="showAddonClickNew(category)">
                        Show Addon
                      </button>
                    </div>
                  </div>

                  <!-- Addon no submenus show items from category.addon_items -->
                  <div class="row" *ngIf="!category.addonSubMenus.length && category.showAddon"
                    [ngClass]="{'item-margin-top': !category.addonSubMenus.length}">

                    <div class="container mt-3">
                      <div class="list-group">
                        <ng-container *ngFor="let item of category.addon_items; let ii = index;">
                          <ng-container
                            *ngTemplateOutlet="addonTemplate; context: { addOnItem: item,index: ii, cat: category }"></ng-container>
                        </ng-container>
                      </div>
                    </div>

                    <!-- HAS SUBS -->
                    <div class="row" *ngIf="category.addonSubMenus.length && category.showAddon">
                      <ul class="menu-sub">
                        <li *ngFor="let sm of category.addonSubMenus;let s=index;">
                          <a href='javascript:void(0)' (click)="onAddonSubMenuClickNew(category,sm,s)"
                            [ngClass]="{'sub-selected': category.activeAddonSubMenuId === sm.ooic_pkid}">
                            {{showALTLanguage === true &&
                            sm.ooic_alternative_name ?
                            sm.ooic_alternative_name : sm.ooic_name}}-why</a>
                        </li>
                      </ul>
                    </div>
                    <!-- HAS SUBS show items from category.activeAddonSubMenu.items-->
                    <div class="row" *ngIf="category.addonSubMenus.length && category.showAddon">
                      <div class="container mt-3">
                        <div class="list-group">
                          <ng-container
                            *ngFor="let aItem of (category.activeAddonSubMenu ? category.activeAddonSubMenu.items : []); let ai = index;">
                            <ng-container
                              *ngTemplateOutlet="addonTemplate; context: { addOnItem: aItem,index: ai, cat: category }"></ng-container>
                          </ng-container>
                        </div>
                      </div>
                    </div>

                  </div>

                  <!-- Addon WITH submenus -->
                  <div class="row" *ngIf="category.addonSubMenus && category.showAddon">
                    <ul class="menu-sub">
                      <li *ngFor="let asm of category.addonSubMenus;let asmi=index;">
                        <a href='javascript:void(0)' (click)="onAddonSubMenuClickNew(category,asm,asmi)"
                          [ngClass]="{'sub-selected': category.activeAddonSubMenuId === asm.ooic_pkid}">
                          {{showALTLanguage === true &&
                          asm.ooic_alternative_name ?
                          asm.ooic_alternative_name : asm.ooic_name}}</a>
                      </li>
                    </ul>
                  </div>

                  <div class="row" *ngIf="category.addonSubMenus && category.showAddon">
                    <div class="container">
                      <div class="list-group">
                        <ng-container
                          *ngFor="let item of (category.activeAddonSubMenu ? category.activeAddonSubMenu.items : []); let ii = index;">
                          <ng-container
                            *ngTemplateOutlet="addonTemplate; context: { addOnItem: item,index: ii, cat: category }"></ng-container>
                        </ng-container>
                      </div>
                    </div>
                  </div>

                </ng-container>





                <!-- Loading -->
                <div *ngIf="category.loading" class="loading">Loading...</div>

                <!-- Error -->
                <div *ngIf="category.error" class="error">Load failed: {{ m.error }}</div>

                <!-- Sentinel trigger -->
                <div #sentinel class="sentinel"></div>
              </section>

            </ng-container>

            <div *ngIf="false" class="debug-root-margin top"></div>
            <div *ngIf="false" class="debug-root-margin bottom"></div>

            <!-- new menu -->
            <div class="row" @myInsertRemoveTrigger *ngIf="!isHorizontalMenu && !item_searched">

              <div class="col-4 menu-text-center" *ngFor="let category of newCategoryList;let i=index;">
                <div class="menu-item-circle text-center" (click)="onMenuClick(category,i)">
                  <!-- <img width="40px" height="40px" class="menu-icon" [src]="category.ooic_image" /> -->

                  <img width="40px" height="40px" class="menu-icon" *ngIf="category.ooic_image.length"
                    [defaultImage]="defaultImage" [lazyLoad]="category.ooic_image" alt="image">
                  <img width="40px" height="40px" class="menu-icon" *ngIf="!category.ooic_image.length"
                    [defaultImage]="defaultImage" [lazyLoad]="defaultItemImage" alt="location image">

                </div>
                <span>{{showALTLanguage === true && category.ooic_alternative_name ? category.ooic_alternative_name :
                  category.ooic_name}}</span> <br>
                <ng-container *ngFor="let time of category.timeList">
                  <span *ngIf="qrCodeType === 3" class="text-muted fa-xs-small-70">{{time.StartTimeString}} -
                    {{time.EndTimeString}}</span>
                </ng-container>
                <span *ngIf="qrCodeType === 3 && (!category.timeList || !category.timeList.length)"
                  class="text-muted fa-xs-small-70">Not
                  Available</span>
              </div>

            </div>
          </div>

        </div>



        <div *ngIf="item_searched" class="row mt-4">
          <div class="col-6 mt-2" [@inOutAnimation]="'in'" *ngFor="let item of searched_item_list;let i = index">
            <ng-container *ngTemplateOutlet="cardTemplate; context: { item: item, index: i }"></ng-container>
          </div>
        </div>

        <div class="mt-5 pt-5" *ngIf="searchValue && searched_item_list.length === 0">
          <div class="row">
            <div class="col text-center">
              <span class="text-warning">Searched item not found please modify your search!!</span>
            </div>
          </div>
        </div>

        <br />
        <br />
        <br />
        <br />
      </div>

    </div>
  </div>
  <!-- ... end content ... -->
</div>


<!-- Drawer & overlay -->
<nav #drawer class="mm-drawer" *ngIf="drawerOpen" [class.show]="drawerOpen" aria-label="Side menu">
  <div class="mm-header">

    <div class="mm-row">
      <div class="h5">Welcome</div>
      <button class="btn mm-history" (click)="openHistory()" aria-label="Close">History</button>
    </div>
    <div class="mm-row">
      <i (click)="onUserClick()" class="fas fa-user cursor fa-lg mr-3"></i>
      <strong>{{userInfo ? userInfo.firstName : 'Guest'}}</strong>
      <button class="mm-close cursor" (click)="closeDrawer()" aria-label="Close">×</button>
    </div>
  </div>

  <div class="mm-content">

    <ul>
      <li class="sub-menu">
        <a href='javascript:void(0)' (click)="mainPage()">
          <img class="icon-img" src="assets/images/homeicons/Menu.png" alt="Image">
          <span class="square-text">Main Menu</span>
        </a>
      </li>
      <li *ngFor="let category of newCategoryList;let i=index;" [ngClass]="{'sub-menu': category.subMenus}">
        <a href='javascript:void(0)' (click)="onMenuClick(category,i, true)" *ngIf="!category.subMenus.length"
          [ngClass]="{'side-nav-selected': selectedMenuId === category.ooic_pkid}">
          <!-- <img class="icon-img" src="./assets/images/dine-in.png" alt="Icon"> -->
          <img class="icon-img" [defaultImage]="defaultImage"
            [lazyLoad]="category.ooic_image.length > 0 ? category.ooic_image : defaultItemImage" alt="image">
          {{showALTLanguage === true && category.ooic_alternative_name ? category.ooic_alternative_name :
          category.ooic_name}}
          <span *ngIf="qrCodeType === 3" class="fa-xs-small-70" style="display: block; margin-left: 45px;">10:00 AM -
            10:00 PM</span>
        </a>

        <a (click)="toggleSubMenu($event, category, i)" href='javascript:void(0)' *ngIf="category.subMenus.length"
          [ngClass]="{'show': showSubmenu && showMenuId === category.ooic_pkid}">
          <img src="./assets/images/dine-in.png" alt="Icon" class="icon-img">
          {{showALTLanguage === true && category.ooic_alternative_name ? category.ooic_alternative_name :
          category.ooic_name}}
          <div class='arrow'></div>
        </a>

        <ul *ngIf="category.subMenus && showMenuId === category.ooic_pkid" [ngClass]="{'show': showSubmenu}">
          <li class="ml-5" *ngFor="let subItem of category.subMenus;">
            <a href='javascript:void(0)' (click)="onRightSideSubMenuClick(subItem,i, true)"
              [ngClass]="{'side-nav-selected': selectedSubMenuId === subItem.ooic_pkid}">
              {{showALTLanguage === true && subItem.ooic_alternative_name ? subItem.ooic_alternative_name :
              subItem.ooic_name}}
            </a>
          </li>

        </ul>
      </li>
    </ul>

    <div class="wrap-contact">
      <hr class="color-white px-2">
      <div class="contact">
        <label class="h4">Customer Support</label>
        <ul>
          <li>
            <label class="cursor"><i class="fas fa-phone mr-2"></i>
              01548400173</label>
          </li>
          <li>
            <label><i class="fas fa-envelope mr-2"></i> customersupport@olarme.com</label>
          </li>

        </ul>
      </div>
      <hr class="color-white px-2">
      <div class="contact">

        <label class="h4">Sales and Finance</label>
        <ul>

          <li><label class="cursor" (click)="onCallClick('0392130100')"><i class="fas fa-phone mr-2"></i>
              0392130100</label></li>
          <li><label for=""><i class="fas fa-envelope mr-2"></i> sales@olarme.com, finance@olarme.com </label>
          </li>

        </ul>
      </div>
      <hr class="color-white px-2">

    </div>

  </div>

  <div class="mm-powered">Powered by OlarMe</div>
</nav>

<div #overlay class="mm-overlay" [class.show]="drawerOpen" (click)="closeDrawer()"></div>



<div class="footer-cart bg-white pb-1 pt-1" *ngIf="newCategoryList.length > 0">
  <div class="">
    <div class="row cursor box-shadow-none p-2">
      <div class="col-4 pr-0 border-right">
        <button disabled class="btn btn-block btn-sm bg-dark text-white box-shadow-none border-radius-right p-2"
          (click)="onScanClick()">
          <i class="fas fa-barcode pr-2"></i>
          <span>{{'COMMON.SCAN_ITEM' | translate }}</span>
        </button>
      </div>
      <div class="col pl-0">
        <button class="btn btn-block btn-sm bg-dark text-white box-shadow-none border-radius-left p-2"
          (click)="onViewCartClickHanlder()">
          <label class="m-0 cursor">
            {{'HOME_PAGE.VIEW_CART' | translate }} <span class="badge badge-light"
              *ngIf="userSelectedStore && userSelectedStore.storeCart && userSelectedStore.storeCart.orderItems">{{userSelectedStore.storeCart.orderItems.length}}</span>
          </label>
          <div class="float-right">
            <label class="pr-3 pl-1 m-0">
              <span *ngIf="userSelectedStore && userSelectedStore.storeCart">
                <small *ngIf="locationSelected && locationSelected.oocls_company_symbol_position === 'BACK'">
                  {{locationSelected.oocls_company_default_currency_symbol}}
                </small>
                <!-- {{userSelectedStore.storeCart.orderSubTotal.toFixed(2)}} -->
                <!-- need uncomment later -->
                <small *ngIf="locationSelected && locationSelected.oocls_company_symbol_position === 'FRONT'">
                  {{locationSelected.oocls_company_default_currency_symbol}}
                </small>
              </span>
            </label>
          </div>
        </button>

      </div>
    </div>


  </div>
</div>

<app-loading-component></app-loading-component>

<ecom-scroll-to-top></ecom-scroll-to-top>

<ng-template #cardTemplate let-item="item" let-i="index" let-cat="cat">

  <div class="card cursor fixed-item-height"
    [ngClass]="{'custom-margin-right': i % 2 === 0,'custom-margin-left': i % 2 !== 0 , 'not-available': !item.categoryAvailable || !item.itemAvailable}"
    (click)="item.categoryAvailable || item.itemAvailable ? onItemClick(item,'PLUS',cat) : null">
    <div *ngIf="!item.categoryAvailable || !item.itemAvailable"
      class="corner-ribbon corner-ribbon-top-right corner-ribbon-primary">
      Not Available</div>
    <!-- <div *ngIf="item?.discounts?.length > 0"
            style="border: 1px solid black !important; border-radius: 1px !important; background:purple; position: absolute; top: 10%;">
            <span class="text-white p-2 font-size-11">{{item.discounts[0]}}</span>
          </div> -->
    <div *ngFor="let item of item.discounts; let i = index" [ngClass]="'discount-item'"
      [ngStyle]="{'top': 10 + i * 10 + '%'}">
      <span class="text-white p-2 font-size-11">{{ item }}</span>
    </div>

    <!-- <img src="http://localhost:4200/assets/images/Itemdefault.jpeg" alt="Avatar" style="width:100%"> -->
    <img *ngIf="item.imagepath.length > 0" [defaultImage]="defaultImage" [lazyLoad]="item.imagepath" alt="image"
      style="width:100%; height: 170px;object-fit: cover;">
    <img *ngIf="!item.imagepath.length" [defaultImage]="defaultImage" [lazyLoad]="defaultItemImage" alt="location image"
      style="width:100%; height: 170px;object-fit: cover;">
    <div class="container">
      <b>{{showALTLanguage === true && item.item_alternative_name ?
        ecomservice.htmlUtil.textTruncate(item.item_alternative_name,
        42) : ecomservice.htmlUtil.textTruncate(item.item_name, 42)}}</b>
      <div *ngIf="item.HasVariant">
        <ul class="text-muted pl-2 text-break font-color-light-grey mb-0 fa-xs-small-70">
          <!-- <li *ngFor="let varient of item.variants;">
                  <span>{{varient}}</span>
                </li> -->
          <ng-container *ngFor="let varient of item.variants;let vi = index">
            <li *ngIf="vi < 3"><span>{{varient}}</span></li>
            <li *ngIf="vi === 2 && item.variants.length > 3">...</li>
          </ng-container>

        </ul>
      </div>
      <div *ngIf="!item.HasVariant">
        <span class="card-text font-weight-bold-500 font-size-16">
          {{item.itemPrice.toFixed(2)}}
        </span>
      </div>

    </div>
  </div>

</ng-template>

<ng-template #addonTemplate let-addOnItem="addOnItem" let-i="index" let-cat="cat">

  <div (click)="addOnItem.categoryAvailable || addOnItem.itemAvailable ? onItemClick(addOnItem,'PLUS',cat) : null"
    class="list-group-item d-flex align-items-start cursor"
    [ngClass]="{'not-available': !addOnItem.categoryAvailable || !addOnItem.itemAvailable}">
    <div *ngIf="!addOnItem.categoryAvailable || !addOnItem.itemAvailable"
      class="corner-ribbon corner-ribbon-top-right corner-ribbon-primary">
      Not Available</div>
    <img *ngIf="addOnItem.imagepath.length > 0" [defaultImage]="defaultImage" [lazyLoad]="addOnItem.imagepath"
      alt="image" style="width:80px;height:80px;object-fit:cover;border-radius:50px">
    <img *ngIf="!addOnItem.imagepath.length" [defaultImage]="defaultImage" [lazyLoad]="defaultItemImage"
      alt="location image" style="width:80px;height:80px;object-fit:cover;border-radius:50px">
    <div class="flex-grow-1 ml-3 d-flex justify-content-between align-items-center">
      <span class="mb-1"> <b>{{showALTLanguage === true && addOnItem.item_alternative_name ?
          ecomservice.htmlUtil.textTruncate(addOnItem.item_alternative_name,
          42) : ecomservice.htmlUtil.textTruncate(addOnItem.item_name, 42)}}</b><br>

        <ul *ngIf="addOnItem.HasVariant" class="text-muted pl-2 text-break font-color-light-grey mb-0 fa-xs-small-70">

          <ng-container *ngFor="let varient of addOnItem.variants;let vi = index">
            <li *ngIf="vi < 3"><span>{{varient}}</span></li>
            <li *ngIf="vi === 2 && addOnItem.variants.length > 3">...</li>
          </ng-container>

        </ul>

      </span>
      <p class="mb-1 text-muted">
        <!-- {{ item.description }} -->
      </p>

      <strong>{{addOnItem.itemPrice.toFixed(2)}}</strong>
    </div>
  </div>



</ng-template>


<app-toast [message]="toastMessage" [visible]="showToast"></app-toast>
<app-drawer [(visible)]="drawerVisible" (visibleChange)="onDrawerVisibleChange($event)">
  <ng-container *ngIf="drawerVisible && item_pkid">
    <app-ecom-item-details2 [item]="item" [onClose]="onClose" [item_pkid]="item_pkid" [iscvsd_pkid]="iscvsd_pkid"
      [category_pkid]="category_pkid" [upSellId]="upSellId"></app-ecom-item-details2>
  </ng-container>
</app-drawer>

<ng-template #serviceTypeModal>
  <div class="modal-body" [ngClass]="{'background-dark-grey': serviceType,'background-light-orange': !serviceType}">
    <div class="row form-group">
      <div class="col-12">
        <i class="fas fa-times fa-lg cursor close pull-right" (click)="onCloseServiceType()"></i>
      </div>
    </div>
    <div class="row" *ngIf="serviceType">

      <div class="col mt-3 text-center h5">{{ serviceType === 'DINE_IN' ? 'Dine In' : (serviceType ===
        'DELIVERY' ?
        'Delivery' : 'Pick Up') }} Requested</div>


    </div>
    
    <div class="row justify-content-center h4" *ngIf="!serviceType">Select</div>
    <div class="row mt-3 justify-content-center">
      <button *ngIf="qrCodeType === 3" (click)="onServiceTypeClick($event,'DELIVERY')"
        class="btn border-0 box-shadow-none service-button">
        Delivery</button>
      <button *ngIf="serviceType !== 'COLLECTION'" (click)="onServiceTypeClick($event,'COLLECTION')"
        class="btn border-0 box-shadow-none service-button">
        Pick up</button>
      <button *ngIf="serviceType !== 'DINE_IN'" (click)="onServiceTypeClick($event,'DINE_IN')"
        class="btn border-0 box-shadow-none service-button">
        Dine in</button>
    </div>
  </div>

</ng-template>

<app-drawer [(visible)]="showOrderTypePopup" [customClass]="'blue'" [showCloseButton]="false">

  <div class="kiosk-page">

    <!-- <button class="close-btn">X</button> -->

    <div class="kiosk-header">

      <img *ngIf="companyLogo" [src]="companyLogo" class="store-logo" alt="logo">

      <div class="question">
        Would you like to Dine with us<br>
        or Take Away?
      </div>

    </div>

    <div class="kiosk-panel">
      <div class="row option-row">

        <div class="col-6 option-col">
          <button class="option-card" [ngClass]="{'selected': serviceType === 'DINE_IN'}"
            (click)="onServiceTypeClick('DINE_IN')">
            Dine In
          </button>
        </div>

        <div class="col-6 option-col">
          <button class="option-card" [ngClass]="{'selected': serviceType === 'COLLECTION'}"
            (click)="onServiceTypeClick('COLLECTION')">
            Take Away
          </button>
        </div>

      </div>
    </div>

  </div>

</app-drawer>

<ng-template #paxModal>
  <div class="modal-body">
    <div class="container p-0">
      <div class="text-center">
        <span class="pax-title font-weight-bold">{{'HOME_PAGE.HOW_MANY_GUESTS' | translate }}</span>
        <div class="keypad">
          <button (click)="addPax(1)">1</button>
          <button (click)="addPax(2)">2</button>
          <button (click)="addPax(3)">3</button>
          <button (click)="addPax(4)">4</button>
          <button (click)="addPax(5)">5</button>
          <button (click)="addPax(6)">6</button>
          <button (click)="addPax(7)">7</button>
          <button (click)="addPax(8)">8</button>
          <button (click)="addPax(9)">9</button>
          <button (click)="addPax(10)">10</button>
          <button class="double" (click)="addPax(11)">{{'HOME_PAGE.MORE_THAN_10' | translate }}</button>
        </div>
      </div>
    </div>

  </div>
</ng-template>

<div class="scroll-to-top" [class.show-scrollTop]="showScrollTop" (click)="scrollMenuToTop()">
  <button type="button" class="btn active btn-sm">
    <i class="fas fa-chevron-up" style="color:white;"></i>
  </button>
</div>

<app-ecom-gift-card *ngIf="showGiftCard" (closeGiftCard)="closeGiftCard($event)"></app-ecom-gift-card>